const MUTATION_TYPE = {
  setUsers: 'setUsers',
  setCurrentPage: 'setCurrentPage',
  setCurrentPageSize: 'setCurrentPageSize',
  setTotal: 'setTotal',
  setPages: 'setPages',
  setUsersIsActive: 'setUsersIsActive' // workaround
}

const ACTION_TYPE = {
  fetchUsers: 'fetchUsers',
  translateStudents: 'translateStudents',
  undoTranslateStudents: 'undoTranslateStudents',
  removeStudents: 'removeStudents',
  changePage: 'changePage',
  changePageSize: 'changePageSize'
}

const GETTER_TYPE = {
  getUser: 'getUser',
  getUsers: 'getUsers',
  getTotal: 'getTotal',
  getPages: 'getPages',
  getCurrentPage: 'getCurrentPage',
  getPaginationPageSize: 'getPaginationPageSize'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
